import {createRouter, createWebHashHistory} from "vue-router";

// import Menu from "@/components/Menu";
// import Schedule from "@/views/schedule";
// import ScheduleDetail from "@/views/scheduleDetail";
// import PromotionPage from "@/views/promotionPage";
// import Scoreboard from "@/views/scoreboard";
// import TeamData from "@/views/teamData";
// import PlayerData from "@/views/playerData";
// import TeamHomepage from "@/views/teamHomepage";
// import PlayerHomepage from "@/views/playerHomepage";
// import Data from "@/views/scheduleDetail/view/Data";
// import Foresight from "@/views/scheduleDetail/view/Foresight";
// import Lineup from "@/views/scheduleDetail/view/Lineup";
// import MatchOuts from "@/views/scheduleDetail/view/MatchOuts";
const Menu = () => import(/* webpackChunkName: "MenuIndex" */ "@/components/Menu.vue");
const Schedule = () => import(/* webpackChunkName: "ScheduleIndex" */ "@/views/schedule/index.vue");
const ScheduleDetail = () => import(
    /* webpackChunkName: "ScheduleDetailIndex" */ "@/views/scheduleDetail/index.vue"
    );
const PromotionPage = () => import(
    // /* webpackChunkName: "PromotionPageIndex" */ "@/views/promotionPage/index.vue"
    /* webpackChunkName: "PromotionPageIndex" 2026*/ "@/views/newPromotionPage/index.vue"
    );
const Scoreboard = () => import(
    /* webpackChunkName: "ScoreboardIndex" */ "@/views/scoreboard/index.vue"
    );
const TeamData = () => import(/* webpackChunkName: "TeamDataIndex" */ "@/views/teamData/index.vue");
const TeamHomepage = () => import(
    /* webpackChunkName: "TeamHomepageIndex" */ "@/views/teamHomepage/index.vue"
    );
const PlayerData = () => import(
    /* webpackChunkName: "PlayerDataIndex" */ "@/views/playerData/index.vue"
    );
const PlayerHomepage = () => import(
    /* webpackChunkName: "PlayerHomepageIndex" */ "@/views/playerHomepage/index.vue"
    );
const Playstat = () => import(
    /* webpackChunkName: "PlayerHomepageIndex" */ "@/views/scheduleDetail/component/PlayerData.vue"
    );
const Foresight = () => import(
    /* webpackChunkName: "ScheduleDetailForesightIndex" */ "@/views/scheduleDetail/view/Foresight.vue"
    );
const Lineup = () => import(
    /* webpackChunkName: "ScheduleDetailLineupIndex" */ "@/views/scheduleDetail/view/Lineup.vue"
    );
const MatchOuts = () => import(
    /* webpackChunkName: "ScheduleDetailMatchOutsIndex" */ "@/views/scheduleDetail/view/MatchOuts.vue"
    );
const Data = () => import(
    /* webpackChunkName: "ScheduleDetailDataIndex" */ "@/views/scheduleDetail/view/Data.vue"
    );

const routes = [
    {
        path: "/",
        redirect: "/index/schedule"
    },
    {
        path: "/index",
        component: Menu,
        meta: {title: '美加墨世界杯', content: ''},
        children: [
            {
                path: "schedule",
                component: Schedule,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "promotionPage",
                component: PromotionPage,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "scoreboard",
                component: Scoreboard,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "teamData",
                component: TeamData,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "playerData",
                component: PlayerData,
                meta: {title: '美加墨世界杯', content: ''}
            }
        ]
    },
    {
        path: "/scheduleDetail",
        redirect: "/scheduleDetail/foresight",
        component: ScheduleDetail,
        meta: {title: '美加墨世界杯', content: ''},
        children: [
            {
                path: "foresight",
                component: Foresight,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "lineup",
                component: Lineup,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "matchOuts",
                component: MatchOuts,
                meta: {title: '美加墨世界杯', content: ''}
            },
            {
                path: "data",
                component: Data,
                meta: {title: '美加墨世界杯', content: ''}
            }
        ]
    },
    {
        path: "/teamHomepage",
        component: TeamHomepage,
        meta: {title: '美加墨世界杯', content: '', dynamic: true}
    },
    {
        path: "/playerHomepage",
        component: PlayerHomepage,
        meta: {title: '美加墨世界杯', content: '', dynamic: true}
    },
    {
        path: "/scheduleDetail/playstat",
        component: Playstat,
        meta: {title: '美加墨世界杯', content: '', noTransition: true}
    }
];

const router = createRouter({
    history: createWebHashHistory(), routes,
});
router.afterEach((to) => {
    document.title = '美加墨世界杯';
    setTimeout(() => {
        if (window.$setShare) {
            const meta = to.meta;
            // 动态页面（球队/球员主页）可以在组件内单独设置
            if (meta.dynamic) return
            const title = meta.title || '美加墨世界杯';
            const content = meta.content || '你想知道关于世界杯战况全在这儿~';
            const img = 'https://pic.cctv.cn/cctv/cctvh5/cctv5/sharelogo/worldCup-logo.png';
            window.$setShare({
                title,
                content,
                link: window.location.href,
                img
            });
        }
    }, 100);
});
export default router